

import React from 'react'
import Footer from '../footer/footer'
import DocumentMeta from 'react-document-meta';
require('./casedetails.scss')
import {Get, wrapResponse} from './../../requst'

export default class CaseDetails extends React.Component{
    static async getInitialProps(ctx){
        const id = ctx.query.id
        const data = await wrapResponse(Get({url:'case/caseDetail',data:{id}}))
      
        const footerProps = await Footer.getInitialProps()

        return {data, footerProps}
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            data:false
        }
       
    }

    componentDidMount() {
        if (this.props.url.pathname.slice(1, 12)== 'casedetails') {
            let aa = document.getElementsByClassName('box_Content');
            // (aa)
            aa.style='background:red';

        }else {
            return null
        }
        
    }

    render(){
        
        if (this.props.data) {
            const meta = {
              title: this.props.data.seo_title,
              description: this.props.data.seo_description,
              // link: {
              //   rel: {
              //     canonical: 'http://example.com/path/to/sub-page'
              //   }
              // },
              meta: {
                charSet: 'utf-8',
                name: {
                  keywords: this.props.data.seo_keywords
                },
              },
              extend: true
            };
            return(
                <DocumentMeta {...meta}>
                    <div style={{overflow:'hidden'}}>
                        <div className = "CaseBox">
                            <div className = "Case_Bg" style={{clear:'both'}}>
                                <img className = "BgImgLeft" src = { require('../../assets/common/images/casebg_2.png') } alt=""/>
                                <img className = "BgImgRight" src = { require('../../assets/common/images/casebg_1.png') } alt=""/>
                            </div>
                            <div>
                                <div className = "Case_Img">
                                    {/*<div className = "Img"></div>*/}
                                    <div className = "Img" dangerouslySetInnerHTML = {this.props.data?{__html:this.props.data.content}:null}>
                                    </div>
                                </div>
                            </div>
                            <div style={{position:'relative',zIndex:'200',marginTop:'40px'}}>
                                <Footer {...this.props.footerProps}/>
                            </div>
                            
                        </div>
                    </div>
                </DocumentMeta>
                
            )
        }else{
            return null
        }
        
    }
}